import { Access, Status } from ".";

export class Detail {
    access: Access;
    status: Status;
}
